<!-- <nav aria-label="breadcrumb" itemscope itemtype="http://schema.org/BreadcrumbList">
    <ol class="breadcrumb" itemprop="itemListElement" style="background-color: transparent;" itemscope
        itemtype="http://schema.org/ListItem">
        <li *ngFor="let item of breadcrumbs; let i = index" class="breadcrumb-item" [class.active]="item.active"
            itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
            <a [href]="baseUrl + item.link.replace('/', '')" (click)="$event.preventDefault()" itemprop="item">
                <span itemprop="name">{{ item.name }}</span>
            </a>
            <meta itemprop="position" [content]="i" />
        </li>
    </ol>
</nav> -->
<nav aria-label="breadcrumb">
    <ol class="breadcrumb" id="breadcrumbs" style="background-color: transparent;">
        <li *ngFor="let item of breadcrumbs; let i = index" class="breadcrumb-item" [class.active]="item.active">
            <a [href]="baseUrl + item.link.replace('/', '')" [routerLink]="item.link" (click)="$event.preventDefault()">
                <span>{{ item.name }}</span>
            </a>
        </li>
    </ol>
</nav>